import { ComponentPropsWithoutRef } from "react";

export function VideoIcon({
  outline,
  ...props
}: ComponentPropsWithoutRef<"svg"> & { outline?: boolean }) {
  return outline ? (
    <svg
      data-component="VideoIcon"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      data-component="VideoIcon"
      viewBox="0 0 20 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20,1.071V13.214a.667.667,0,0,1-.435.658.776.776,0,0,1-.279.056.663.663,0,0,1-.5-.212l-4.5-4.5v1.853a3.22,3.22,0,0,1-3.214,3.214H3.214a3.1,3.1,0,0,1-2.271-.943A3.1,3.1,0,0,1,0,11.071V3.214A3.1,3.1,0,0,1,.943.943,3.1,3.1,0,0,1,3.214,0h7.857a3.1,3.1,0,0,1,2.271.943,3.1,3.1,0,0,1,.943,2.271V5.056l4.5-4.487a.663.663,0,0,1,.5-.212.776.776,0,0,1,.279.056A.667.667,0,0,1,20,1.071Z" />
    </svg>
  );
}
